import moment from "moment";
var moments = require('moment-timezone');

export let stringToMomentDate = (dateTimeValue, timeZone) => {
  dateTimeValue = dateTimeValue.substring(0, 19);
  var localTime = moment.utc(dateTimeValue).toDate();
  const dbFormatDateTime = moment(dateTimeValue).format("YYYY-MM-DD HH:mm:ss"); // For db transanction only
  const startDate = moment(dateTimeValue).format("DD MMMM");
  const day = moment(dateTimeValue).format("dddd");
  const sday = moment(dateTimeValue).format("ddd");
  const time =
    timeZone != undefined && timeZone != ""
      ? moment(localTime).tz(timeZone).format("HH:mm")
      : moment(dateTimeValue).format("HH:mm"); //show host time
  const userTimezone = moments.tz.guess();
  const conversionTime = moment
    .utc(dateTimeValue)
    .tz(userTimezone)
    .format("HH:mm");
  const dateTime =
    timeZone != undefined && timeZone != ""
      ? moment(dateTimeValue).tz(timeZone).format("dddd, DD,  hh:mm a")
      : moment.utc(dateTimeValue).tz(userTimezone).format("dddd, DD, hh:mm a"); // For render date & time both in am / pm format

  // Show Next Day Date Time for (Your Time)
  const yourTime = moment
    .utc(dateTimeValue)
    .tz(userTimezone)
    .format("YYYY-MM-DD");
  const hostTime =
    timeZone != undefined && timeZone != ""
      ? moment(localTime).tz(timeZone).format("YYYY-MM-DD")
      : moment(dateTimeValue).format("YYYY-MM-DD");
  var diff = moment(hostTime).isSame(yourTime);
  var newDate = !diff
    ? moment.utc(dateTimeValue).tz(userTimezone).format("HH:mm - ddd, DD MMM")
    : moment.utc(dateTimeValue).tz(userTimezone).format("HH:mm");
  //
  return {
    startDate,
    dateTime,
    day,
    time,
    sday,
    conversionTime,
    dbFormatDateTime,
    newDate,
  };
};
